"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateType = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const stateType = exports.stateType = ['error', 'warning', 'ok'];
const formContext = /*#__PURE__*/_react.default.createContext({
  controlId: undefined,
  isFocus: false,
  isInvalid: false,
  required: false,
  state: 'ok',
  onFocus: undefined,
  onBlur: undefined,
  onRequiredChange: undefined,
  setIsInvalid: undefined,
  setState: undefined
});
var _default = exports.default = formContext;